import styled from 'styled-components';
import { getSpace, mq, getTextType } from '../../../stylesheets/tools';

const StyledFilterSwitch = styled.div`
  .filterswitch__headline {
    ${getTextType('secondary')};
    text-align: center;
  }
  .filterswitch__inner {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 40px 0 40px 0;
  }

  .filterswitch__calwrapper {
    position: relative;
    margin: 0 0;

    > div:first-child {
      top: -100px;
      left: 20px;

      ${mq('m')} {
        top: -40px;
        left: -40px;
      }
    }

    > div:last-child {
      margin-top: 120px;

      ${mq('m')} {
        margin-top: 0;
      }
    }
  }

  .filterswitch__line {
    width: 0.5px;
    height: 40px;
    border-left: 1px solid black;
    margin: 0 20px 0 20px;
  }

  .filterswitch__button {
    ${getTextType('subline')};
    color: #000;
    text-transform: uppercase;
  }

  .filterswitch__button--active {
    pointer-events: none;
    color: ${props => props.theme.siteTheme.primary};
  }

  .result__container {
    margin-top: ${getSpace('l')};
    margin-left: 0;
    ${mq('m')} {
      margin-left: ${getSpace('l')};
    }
  }

  .filterswitch__noResults {
    display: flex;
    margin: ${getSpace('l')} 0;
    justify-content: center;

    &__close {
      margin-left: ${getSpace('m')};
    }
  }
`;

export default StyledFilterSwitch;
